// Document types - re-export generated API types with clean aliases

export type {
  documents_DocumentResponse as Document,
  documents_CreateDocumentRequest as CreateDocumentRequest,
  documents_UpdateDocumentRequest as UpdateDocumentRequest,
  documents_ListDocumentsResponse as DocumentListResponse,
  documents_DocumentVersionResponse as DocumentVersion,
  documents_ListVersionsResponse as DocumentVersionListResponse,
  documents_AttachFileRequest as AttachFileRequest,
  documents_ReplaceVersionRequest as ReplaceVersionRequest,
  documents_DocumentAccessLogResponse as DocumentAccessLog,
  documents_ListAccessLogsResponse as DocumentAccessLogListResponse,
} from '@/api';

// Filter interfaces for query hooks
export interface DocumentsFilters {
  page?: number;
  page_size?: number;
  search?: string;
  category?: string;
  confidentiality?: string;
  is_published?: boolean;
  display_target?: string;
}

export interface DocumentVersionsFilters {
  limit?: number;
  offset?: number;
}

export interface DocumentAccessLogsFilters {
  page?: number;
  page_size?: number;
}

// Document form data for React Hook Form
export interface DocumentFormData {
  name: string;
  description?: string;
  confidentiality: string;
  category: string;
  is_published: boolean;
  display_targets: string[];
}

// Option values only; the translated names live in components/documents/documentLabels.ts.
export const DISPLAY_TARGETS = [{ value: 'parent_app' }, { value: 'employee_app' }] as const;

export const CONFIDENTIALITY_LEVELS = [
  { value: 'public' },
  { value: 'internal' },
  { value: 'confidential' },
] as const;

export const DOCUMENT_CATEGORIES = [
  { value: 'agb' },
  { value: 'staff_guidelines' },
  { value: 'instructions' },
  { value: 'policies' },
  { value: 'info_sheets' },
  { value: 'other' },
] as const;
